export class EditionNotFoundInCache extends Error {
  constructor(msg: string) {
    super(msg);

    Object.setPrototypeOf(this, EditionNotFoundInCache.prototype);
  }
}
